export default __webpack_public_path__ + "static/media/ServicesArrow.982127f6.svg";